import { Injectable } from '@angular/core';
import { ChatOrganization } from '../../domain/models/organization.model';
import { OrganizationDto } from '../dtos/organization.dto';

@Injectable()
export class OrganizationMapper {
  public toOrganization(dto: OrganizationDto): ChatOrganization {
    return { id: dto.Id, name: dto.Name };
  }
}
